<template>
    <div class="header-left" id="logo">
        <span class="logo">
          <img class="img" v-if="systemImage" :src="systemImage"/>
          <img class="img" src="../../assets/logo.png" v-else/>
        </span>
        <h3 class="title">{{systemName ? systemName : $t('global.defaultSystemName')}}</h3>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'ZLogo',
        computed: {
            ...mapGetters([
                'systemName','systemImage'
            ])
        },
        data() {
            return {
                // defaultOrgImg
            }
        }
    }
</script>
<style lang="less" scoped>
.header-left {
  width: 300px;
  display: grid;
  grid-template-columns: 50px auto;
  grid-gap: 5px;
  .logo {
    display: block;
    .img {
      max-width: 50px;
    }
  }
  .title {
    font-size: 16px;
    white-space: nowrap;
    color: #fff;
  }
}
</style>

